import request from '@/utils/request'
// 获取手机验证码
export function getVerifyCode(data) {
  return request({
    // url: '/common/send/' + phone,
    url: '/front/auth/sendPhoneCode',
    method: 'post',
    data: data
  })
}
// 获取手机验证码1
export function getVerifyPhoneCode(data) {
  return request({
    // url: `/front/user/sendPhoneCode?phoneNum=${data.phoneNum}&kaptcha=${data.kaptcha}&flag=${data.flag}`,
    url: '/front/user/sendPhoneCode',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// export function getVerifyPhoneCodeBd(data) {
//   return request({
//     // url: `/front/user/sendPhoneCode?phoneNum=${data.phoneNum}&kaptcha=${data.kaptcha}&flag=${data.flag}`,
//     url: '/front/user/sendPhoneVCode',
//     method: 'post',
//     data: data,
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
//     }
//   })
// }

export function getVerifyPhoneCodeBd(data) {
  return request({
    url: '/front/user/sendPhoneVCodeByUserIdNew',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

// 注册
export function userRegister(data) {
  return request({
    url: '/front/auth/register',
    method: 'post',
    data: data
  })
}
// 获取图形验证码
export function getCode(params) {
  return request({
    url: '/common/kaptcha/create',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
// 登录
// export function userLoginRead(data) {
//   return request({
//     url: '/front/user/login',
//     method: 'post',
//     data: data
//   })
// }

// 登录
export function userLoginRead(params) {
  return request({
    url: '/front/auth/login',
    method: 'post',
    data: params
  })
}

export function userLogin(data) {
  return request({
    url: '/front/auth/login-new',
    method: 'post',
    data: data
  })
}
// 重置密码
export function resetPassWord(data) {
  return request({
    url: '/front/auth/restPassWord',
    method: 'post',
    data: data
  })
}
// 修改个人信息
export function updateUserInfo(data) {
  return request({
    url: '/front/user/updateInfo',
    method: 'post',
    data: data
  })
}
// 修改手机号
export function updateUserPhone(data) {
  return request({
    url: '/front/user/changePhoneNum',
    method: 'post',
    data: data
  })
}
// 修改密码
export function updateUserPassword(data) {
  return request({
    url: '/front/user/changePwd',
    method: 'post',
    data: data
  })
}

// 查询用户信息
export function getUserInfo(params) {
  return request({
    url: '/front/user/info',
    method: 'get',
    params: params
  })
}
// 退出
export function exitLogin() {
  return request({
    url: '/front/user/logout?flag=0',
    method: 'post',
  })
}

// 实名认证
export function personAuth(data) {
  return request({
    url: '/front/user/personAuth',
    method: 'post',
    data: data
  })
}

// 平台访问量
export function addVisitor(params) {
  return request({
    url: '/common/visitors/add',
    method: 'get',
    params: params
  })
}
// 首页平台统计
export function getStatistics(params) {
  return request({
    url: '/agency/organization/findCulteAll',
    method: 'get',
    params: params
  })
}

// 查询手机号是否为初次使用
export function getBangDingPhone(params) {
  return request({
    url: '/front/user/verifyPhoneIsOccupied',
    method: 'get',
    params: params
  })
}
// 绑定手机号
export function BangDingPhone(data) {
  return request({
    url: '/front/user/fastAccountNumberNew',
    method: 'post',
    data: data
  })
}

// 获取微信登录参数
export function getAuth() {
  return request({
    url: '/wx/open/getAuth',
    method: 'get',
  })
}

// 第三方账号绑定
export function setLoginUser(data) {
  return request({
    url: '/wx/open/social-login',
    method: 'post',
    data,
  })
}
